import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Attach JWT (if present) to every request
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("dilli_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// ---------- Places / lists ----------
export const fetchPlaces = async ({ category, area, q } = {}) => {
  const params = {};
  if (category && category !== "all") params.category = category;
  if (area && area !== "all") params.area = area;
  if (q) params.q = q;
  const { data } = await axios.get(`${API}/places`, { params });
  return data;
};

export const fetchAllPlaces = async () => {
  const { data } = await axios.get(`${API}/places`);
  return data;
};

export const fetchAreas = async () => {
  const { data } = await axios.get(`${API}/areas`);
  return data;
};

export const fetchLists = async () => {
  const { data } = await axios.get(`${API}/lists`);
  return data;
};

export const fetchListDetail = async (id) => {
  const { data } = await axios.get(`${API}/lists/${id}`);
  return data;
};

export const submitPlace = async (payload) => {
  const { data } = await axios.post(`${API}/places`, payload);
  return data;
};

// ---------- Auth ----------
export const apiSignup = async (email, password) => {
  const { data } = await axios.post(`${API}/auth/signup`, { email, password });
  return data;
};

export const apiLogin = async (email, password) => {
  const { data } = await axios.post(`${API}/auth/login`, { email, password });
  return data;
};

export const apiMe = async () => {
  const { data } = await axios.get(`${API}/auth/me`);
  return data;
};

// Exchange Emergent Google session_id for our JWT (backend calls provider)
export const apiSession = async (sessionId) => {
  const { data } = await axios.post(`${API}/auth/session`, { session_id: sessionId });
  return data;
};

// ---------- Premium lists ----------
export const createList = async (payload) => {
  const { data } = await axios.post(`${API}/lists`, payload);
  return data;
};

// ---------- Admin ----------
export const adminStats = async () => {
  const { data } = await axios.get(`${API}/admin/stats`);
  return data;
};
export const adminListUsers = async () => {
  const { data } = await axios.get(`${API}/admin/users`);
  return data;
};
export const adminPatchUser = async (id, patch) => {
  const { data } = await axios.patch(`${API}/admin/users/${id}`, patch);
  return data;
};
export const adminDeleteUser = async (id) => {
  const { data } = await axios.delete(`${API}/admin/users/${id}`);
  return data;
};
export const adminCreatePlace = async (payload) => {
  const { data } = await axios.post(`${API}/admin/places`, payload);
  return data;
};
export const adminUpdatePlace = async (id, payload) => {
  const { data } = await axios.put(`${API}/admin/places/${id}`, payload);
  return data;
};
export const adminDeletePlace = async (id) => {
  const { data } = await axios.delete(`${API}/admin/places/${id}`);
  return data;
};
export const adminUpdateList = async (id, payload) => {
  const { data } = await axios.put(`${API}/admin/lists/${id}`, payload);
  return data;
};
export const adminDeleteList = async (id) => {
  const { data } = await axios.delete(`${API}/admin/lists/${id}`);
  return data;
};

// ---------- Payments ----------
export const createOrder = async () => {
  const { data } = await axios.post(`${API}/payments/create-order`);
  return data;
};

export const verifyPayment = async (payload) => {
  const { data } = await axios.post(`${API}/payments/verify`, payload);
  return data;
};
